// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
    height: 100vh;
    /* width: 100%; */
    text-align: center;
    z-index: 2;
    clip-path: polygon(0 0, 100% 0, 100% 93%, 74% 100%, 0 89%);
    background-repeat: no-repeat;
    background-size: cover;
}
.pinkHero{
    position: absolute;
    z-index: 1;
    clip-path: polygon(100% 40%, 100% 95%, 71% 110%, 61% 100%);  
    bottom: 0%;
    right: 0%;
    /* background-color:rgba(201, 51, 116, 0.77); */
    width: 1180.5px;
    height:708.5px;
}
.home_heading{
    padding: 8rem 10%;
    position: absolute;
    color: var(--t-white);
    z-index: 5;
}
.ul{
    display: flex;
    list-style: none;
    justify-self: start;
    gap: 1rem;
}
.ul li::before{
    content: "\\2022";
    font-size: 1.3rem;

}
.ul li{
    display: inline;
    justify-self:flex-start;
}
@media only screen and (max-width: 850px) {
.pinkHero{  
    clip-path: polygon(100% 40%, 100% 93%, 91% 120%, 61% 100%); 
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Hero/Hero.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,0DAA0D;IAC1D,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,0DAA0D;IAC1D,UAAU;IACV,SAAS;IACT,+CAA+C;IAC/C,eAAe;IACf,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,iBAAiB;;AAErB;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;AACA;IACI,0DAA0D;IAC1D;AACJ","sourcesContent":[".hero {\n    height: 100vh;\n    /* width: 100%; */\n    text-align: center;\n    z-index: 2;\n    clip-path: polygon(0 0, 100% 0, 100% 93%, 74% 100%, 0 89%);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.pinkHero{\n    position: absolute;\n    z-index: 1;\n    clip-path: polygon(100% 40%, 100% 95%, 71% 110%, 61% 100%);  \n    bottom: 0%;\n    right: 0%;\n    /* background-color:rgba(201, 51, 116, 0.77); */\n    width: 1180.5px;\n    height:708.5px;\n}\n.home_heading{\n    padding: 8rem 10%;\n    position: absolute;\n    color: var(--t-white);\n    z-index: 5;\n}\n.ul{\n    display: flex;\n    list-style: none;\n    justify-self: start;\n    gap: 1rem;\n}\n.ul li::before{\n    content: \"\\2022\";\n    font-size: 1.3rem;\n\n}\n.ul li{\n    display: inline;\n    justify-self:flex-start;\n}\n@media only screen and (max-width: 850px) {\n.pinkHero{  \n    clip-path: polygon(100% 40%, 100% 93%, 91% 120%, 61% 100%); \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
